import { CardFacadeBase } from 'utils/facades/card-facade-base';

class InfoFacade extends CardFacadeBase {}

export { InfoFacade };
